import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { Observable } from 'rxjs';

import { RouteUrl } from '../../../../app.routes';
import { DataStoreService } from '../../../../core/services/data-store.service';
import { StoreKey } from '../../../../core/services/data-store.type';
import { CreateStep } from '../create.type';

@Injectable({
  providedIn: 'root'
})
export class SummaryGuard implements CanActivate {

  v3login: boolean;

  constructor(
    private router: Router,
    private dataStore: DataStoreService
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const createData = this.dataStore.getData(StoreKey.CREATE);

    if (createData && createData.step === CreateStep.SUMMARY) {
      return true;
    }

    this.router.navigate([RouteUrl.TEMPLATES]);
    return false;
  }
}
